import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import user from "./user";
import service from "./service";
import leave from "./leave";
import travel from "./travel";
import misc from "./misc";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navVisible: true,
  },
  getters: {
    navVisible(state) {
      return state.navVisible;
    },
  },
  mutations: {
    setNavVisible(state, visible) {
      state.navVisible = visible;
    },
  },
  modules: {
    auth,
    user,
    service,
    leave,
    travel,
    misc,
  },
});
